import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { FaSpinner } from "react-icons/fa";
import { MOVIMENTACAO_ESTILO, formatarDataHora } from "./tiUtils";

/** Linha do tempo de movimentações do ativo (somente leitura). Os dados são buscados ao abrir. */
export default function HistoricoAtivoModal({ visible, onHide, service, ativo }) {
    const [historico, setHistorico] = useState([]);
    const [carregando, setCarregando] = useState(false);

    const ativoId = ativo?.id;

    useEffect(() => {
        if (!visible || !ativoId) return;
        let ativoEfeito = true;
        setCarregando(true);
        service.movimentacoes(ativoId)
            .then(res => { if (ativoEfeito) setHistorico(res.data || []); })
            .catch(() => { if (ativoEfeito) setHistorico([]); })
            .finally(() => { if (ativoEfeito) setCarregando(false); });
        return () => { ativoEfeito = false; };
    }, [visible, ativoId, service]);

    return (
        <Dialog
            header={`Histórico — ${ativo?.nomenclatura || ativo?.patrimonio || `#${ativoId ?? ""}`}`}
            visible={visible}
            onHide={onHide}
            blockScroll
            className="w-[98%] md:w-[820px]"
            contentClassName="pt-3"
        >
            {carregando ? (
                <div className="flex items-center justify-center gap-2 py-10 text-muted-foreground">
                    <FaSpinner className="animate-spin" size={18} /> <span className="text-sm">Carregando...</span>
                </div>
            ) : historico.length === 0 ? (
                <p className="text-sm text-muted-foreground">Nenhuma movimentação registrada.</p>
            ) : (
                <ol className="relative border-l border-border ml-2 space-y-5">
                    {historico.map(m => (
                        <li key={m.id} className="ml-4">
                            <span className={`absolute -left-1.5 mt-1.5 w-3 h-3 rounded-full ${MOVIMENTACAO_ESTILO[m.tipo] || "bg-slate-400"}`} />
                            <div className="flex flex-wrap items-baseline gap-x-3">
                                <span className="text-sm font-semibold text-foreground">{m.tipoRotulo}</span>
                                <span className="text-xs text-muted-foreground">
                                    {formatarDataHora(m.dataHora)} · {m.usuarioNome || "Sistema"}
                                </span>
                            </div>
                            {m.motivo && <p className="text-sm mt-0.5">Motivo: {m.motivo}</p>}
                            {m.alteracoes?.length > 0 && (
                                <table className="mt-2 text-xs w-full max-w-3xl">
                                    <thead>
                                        <tr className="text-left text-muted-foreground">
                                            <th className="pr-3 py-1 font-medium">Campo</th>
                                            <th className="pr-3 py-1 font-medium">Anterior</th>
                                            <th className="py-1 font-medium">Novo</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {m.alteracoes.map(a => (
                                            <tr key={a.campo} className="border-t border-border/60">
                                                <td className="pr-3 py-1">{a.rotulo}</td>
                                                <td className="pr-3 py-1 text-muted-foreground">{a.anterior ?? "—"}</td>
                                                <td className="py-1 font-medium">{a.novo ?? "—"}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </li>
                    ))}
                </ol>
            )}
        </Dialog>
    );
}
